import { components } from '@/utils'

import copyright from '@/components/misc/copyright'
import localeSwitch from '@/components/misc/locale'
import version from '@/components/misc/version'

function renderContent(h) {
  return h(
    components.content,
    {
      style: { placeContent: 'center' }
    },
    [ this.$slots.default ]
  )
}

function renderCopyright(h) {
  return h(
    'div',
    {
      class: 'flex grid-gap--4'
    },
    [
      h(version),
      h(copyright)
    ]
  )
}
function renderLinks(h) {
  return this.links.map(name => {
    return h(
      'router-link',
      {
        class: 'link',
        props: { to: { name } }
      },
      [ this.getTranslate(`${name}.title`) ]
    )
  })
}
function renderActions(h) {
  return h(
    'div',
    {
      class: 'flex grid-gap--8'
    },
    [
      h(localeSwitch),
      renderLinks.call(this, h)
    ]
  )
}
function renderFooter(h) {
  return h(
    components.footer,
    {
      props: {
        fixed: true,
        simple: true,
        height: 38
      }
    },
    [
      renderCopyright.call(this, h),
      renderActions.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    components.app,
    {},
    [
      renderContent.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
